export const renderStatus = (status: number) => {
    switch (status) {
        case 1 :
            return "In Progress"
        case 2 :
            return "Done"
        case 3 :
            return "Cancelled"
        default :
            return "Not Done"
    }
 }